export class EcmGlobalThisUtil {
    static getLocation() {
        return globalThis.location;
    }

    static setLocationHref(url: string) {
        globalThis.location.href = url;
    }
}
